/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 6f1bf43c7b12
 */

import * as z from "zod";

export type StructuredMetadataValue = string | number | Array<string>;

export const StructuredMetadataValue$zodSchema: z.ZodType<
  StructuredMetadataValue
> = z.union([
  z.string(),
  z.int(),
  z.array(z.string()),
]);
